var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card-rank card-rank-top"},[_c('span',{staticClass:"card-rank-bg",class:[
                'suit-' + _vm.suit,
                'rank-' + _vm.rank
            ]},[_vm._v(_vm._s(_vm.rank))]),_vm._v(" "),_c('span',{staticClass:"card-rank-upper",class:[
                'suit-' + _vm.suit,
                'rank-' + _vm.rank
            ]},[_vm._v(_vm._s(_vm.rank))])]),_vm._v(" "),_c('div',{staticClass:"card-rank card-rank-bottom"},[_c('span',{staticClass:"card-rank-bg",class:[
                'suit-' + _vm.suit,
                'rank-' + _vm.rank
            ]},[_vm._v(_vm._s(_vm.rank))]),_vm._v(" "),_c('span',{staticClass:"card-rank-upper",class:[
                'suit-' + _vm.suit,
                'rank-' + _vm.rank
            ]},[_vm._v(_vm._s(_vm.rank))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }